module.exports = __webpack_public_path__ + "img/blog-7.87690014.webp";